import { resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-44a8d0de")

_pushScopeId("data-v-44a8d0de")
const _hoisted_1 = { class: "intro-wrapped" }
const _hoisted_2 = { class: "main" }
const _hoisted_3 = { class: "main__section--wide" }
const _hoisted_4 = { class: "online-care-list card-list" }
const _hoisted_5 = { class: "list-header" }
const _hoisted_6 = { class: "-bold" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 신청내역조회 ")
const _hoisted_8 = {
  key: 0,
  class: "pi pi-chevron-down -bold"
}
const _hoisted_9 = {
  key: 1,
  class: "pi pi-chevron-up -bold"
}
const _hoisted_10 = { class: "list-header" }
const _hoisted_11 = { class: "-bold" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" 완료내역 ")
const _hoisted_13 = {
  key: 0,
  class: "pi pi-chevron-down -bold"
}
const _hoisted_14 = {
  key: 1,
  class: "pi pi-chevron-up -bold"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_OnlineCareIntro = _resolveComponent("OnlineCareIntro")
  const _component_RequestCardList = _resolveComponent("RequestCardList")
  const _directive_scrollIcon = _resolveDirective("scrollIcon")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _withDirectives(_createVNode("section", _hoisted_1, [
      _createVNode(_component_OnlineCareIntro, { isImage: false })
    ], 512), [
      [_directive_scrollIcon]
    ]),
    _createVNode("main", _hoisted_2, [
      _createVNode("section", _hoisted_3, [
        _createVNode("section", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode("h3", _hoisted_6, [
              _hoisted_7,
              _createVNode("span", {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.reqShow = !_ctx.reqShow)),
                class: "-royalBlue"
              }, [
                (_ctx.reqShow)
                  ? (_openBlock(), _createBlock("i", _hoisted_8, " 접기"))
                  : (_openBlock(), _createBlock("i", _hoisted_9, " 열기"))
              ])
            ]),
            _createVNode("a", {
              class: "-royalBlue",
              onClick: _cache[2] || (_cache[2] = () => _ctx.router.go(0))
            }, "새로고침")
          ]),
          _createVNode(_component_RequestCardList, {
            type: _ctx.RequestListType.Request,
            kind: _ctx.RequestKindTypes.OnlineCare,
            isShow: _ctx.reqShow
          }, null, 8, ["type", "kind", "isShow"]),
          _createVNode("div", _hoisted_10, [
            _createVNode("h3", _hoisted_11, [
              _hoisted_12,
              _createVNode("span", {
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.resShow = !_ctx.resShow)),
                class: "-royalBlue"
              }, [
                (_ctx.resShow)
                  ? (_openBlock(), _createBlock("i", _hoisted_13, " 접기 "))
                  : (_openBlock(), _createBlock("i", _hoisted_14, " 열기"))
              ])
            ]),
            _createVNode("a", {
              class: "-royalBlue",
              onClick: _cache[4] || (_cache[4] = () => _ctx.router.go(0))
            }, "새로고침")
          ]),
          _createVNode(_component_RequestCardList, {
            type: _ctx.RequestListType.Response,
            kind: _ctx.RequestKindTypes.OnlineCare,
            isShow: _ctx.resShow
          }, null, 8, ["type", "kind", "isShow"])
        ])
      ])
    ])
  ], 64))
})